import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoWhite from "../../assets/logo/logo-white.svg?react";
import { useIsCompactView } from "../../core_stores/useIsCompactViewStore";
import { WelcomeFooter } from "../welcome/components/WelcomeFooter";
import { typography } from "../../design/tokens";

const FLUTTER_FACTS = [
  "Flutter uses Dart, a language that can compile to native ARM & x64 machine code, which is why Flutter apps are so fast.",
  "Flutter's 'hot reload' feature lets developers see code changes in under a second without restarting the app or losing its state.",
  "Flutter renders its own pixels directly, bypassing platform widgets entirely. This means perfect consistency across iOS, Android, and web.",
  "The Flutter framework is written in over 1.5 million lines of code, but your compiled app only includes the parts you actually use.",
  "Flutter's animation system runs at 60 fps (or 120 fps on devices that support it) by default, creating buttery-smooth user experiences.",
  "Google Pay, Alibaba, BMW, and eBay all use Flutter in production apps with millions of users.",
  "Flutter's widget tree can have thousands of widgets, but it rebuilds only the parts that change, keeping performance lightning-fast.",
  "Flutter compiles to native code for mobile, but can also target web (JavaScript) and desktop (Windows, macOS, Linux) from the same codebase.",
  "Flutter's 'everything is a widget' philosophy means even padding, alignment, and gestures are widgets - making UI code incredibly composable.",
  "Flutter apps can be as small as 4.7 MB when compiled, making them competitive with native apps despite including the entire framework.",
];

export function NotFoundPage() {
  const navigate = useNavigate();
  const isCompactView = useIsCompactView();
  const [randomFact, setRandomFact] = useState("");

  // Select random fact on mount
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * FLUTTER_FACTS.length);
    setRandomFact(FLUTTER_FACTS[randomIndex]);
  }, []);

  const handleGoHome = () => {
    navigate("/", { replace: true });
  };

  return (
    <div className="relative w-[100dvw] h-[100dvh] overflow-hidden flex flex-col bg-gradient-hero-dark">
      {/* Logo */}
      <div className="p-5">
        <LogoWhite className="scale-[8.45] origin-left" />
      </div>

      {/* Content - Centered */}
      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-[680px] flex flex-col items-center text-center">
          {/* Massive 404 */}
          <h1
            className={`${
              isCompactView ? "text-[100px]" : "text-[140px]"
            } font-bold opacity-95 leading-none tracking-[-0.04em] drop-shadow-[0_12px_24px_rgba(0,0,0,0.7)]`}
            style={{ color: "#E6E6E6" }}
          >
            404
          </h1>

          {/* Main heading */}
          <h2
            className={`${
              isCompactView ? typography.size["2xl"] : typography.size["4xl"]
            } ${typography.weight.semibold} opacity-90 tracking-[-0.01em] mt-2`}
            style={{ color: "#E6E6E6" }}
          >
            Page Not Found
          </h2>

          {/* Description */}
          <p
            className={`${typography.size.lg} ${typography.weight.normal} opacity-60 mt-5 max-w-[480px] leading-relaxed`}
            style={{ color: "#E6E6E6" }}
          >
            The page you're looking for doesn't exist or has been moved
          </p>

          {/* Flutter Fact Card */}
          {randomFact && (
            <div
              className="w-full max-w-[560px] mt-8 p-6 rounded-2xl text-left"
              style={{
                backgroundColor: "rgba(26, 29, 36, 0.5)",
                border: "1px solid rgba(255, 255, 255, 0.08)",
              }}
            >
              <p
                className={`${typography.size.sm} ${typography.weight.bold} mb-3 flex items-center gap-2`}
                style={{ color: "#E6E6E6" }}
              >
                <span>💡</span>
                <span>Flutter Fact</span>
              </p>
              <p
                className={`${typography.size.base} ${typography.weight.normal} opacity-85 leading-relaxed`}
                style={{ color: "#E6E6E6" }}
              >
                {randomFact}
              </p>
            </div>
          )}

          {/* Action Button */}
          <button
            className="mt-10 px-10 py-3 rounded-full
              bg-primary-blue text-white
              font-semibold text-base tracking-wide
              hover:opacity-90 transition-opacity duration-300
              drop-shadow-[0_8px_16px_rgba(59,130,246,0.5)]"
            onClick={handleGoHome}
          >
            Go to Home
          </button>
        </div>
      </div>

      {/* Footer */}
      <WelcomeFooter />
    </div>
  );
}
